"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _moment = _interopRequireDefault(require("moment"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdSpinner = _interopRequireDefault(require("cccisd-spinner"));
var _dataProcessors = _interopRequireDefault(require("./dataProcessors"));
var _DynamicForm = _interopRequireDefault(require("./components/DynamicForm.js"));
var _getEmptyFieldValue = _interopRequireDefault(require("../../helpers/getEmptyFieldValue.js"));
var _formWrapper = require("../../reducers/formWrapper.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;

/**
 * Appdefs FormWrapper component
 * This component takes a JSON form definition and transforms it into a
 * redux-form with default values, validation, and error handling.
 */
var FormWrapper = /*#__PURE__*/function (_React$Component) {
  function FormWrapper() {
    var _this;
    _classCallCheck(this, FormWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormWrapper, [].concat(args));
    /* /////////////////////////////////////////////////////////////////////////
    // REACT LIFECYCLE METHODS ////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    //  Alter to query with filter
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$props, filterGroup, form, row, operation, graphql, filterGroupEmpty;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$props = _this.props, filterGroup = _this$props.filterGroup, form = _this$props.form, row = _this$props.row;
            operation = (0, _isEmpty2["default"])(row) ? 'create' : 'edit';
            graphql = form.graphql && form.graphql[operation] ? form.graphql[operation] : {};
            filterGroupEmpty = !filterGroup || filterGroup === 0;
            if (!filterGroupEmpty) {
              graphql.requiredVariables[0].trainingOrg = filterGroup;
            }
            if ((0, _isEmpty2["default"])(graphql)) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return _this.props.runQuery(row, graphql.gql_query, graphql.requiredVariables);
          case 1:
            _context.n = 3;
            break;
          case 2:
            _this.props.unsetLoadingState();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.props.setMatchedUser({});
      _this.props.resetState();
      _this.props.unsetGraphqlData();
    });
    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "getFieldTypes", function (fields) {
      var fieldTypes = {};
      fields.forEach(function (f) {
        fieldTypes[f.reduxFieldHandle] = f;
      });
      fieldTypes.formHandle = {
        handle: 'formHandle',
        reduxFieldHandle: 'formHandle',
        isRequired: true,
        type: 'pawnDataField',
        displaySettings: {
          renderAs: 'hidden',
          fieldProps: {},
          label: '',
          placeholder: ''
        }
      };
      return fieldTypes;
    });
    _defineProperty(_this, "getStaticValue", function (f) {
      var _f$displaySettings = f.displaySettings,
        fieldProps = _f$displaySettings.fieldProps,
        renderAs = _f$displaySettings.renderAs;
      if (renderAs.includes('date')) {
        return _this.processDate(fieldProps.initialValue);
      }
      if (['toggle', 'checkbox'].includes(renderAs)) {
        return _this.processBool(fieldProps.initialValue);
      }
      return fieldProps.initialValue;
    });
    _defineProperty(_this, "handleSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values) {
        var _this$props2, form, matchedUser, routes, row, userAvailable;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this$props2 = _this.props, form = _this$props2.form, matchedUser = _this$props2.matchedUser, routes = _this$props2.routes, row = _this$props2.row, userAvailable = _this$props2.userAvailable;
              if (!(form.isUserForm && !userAvailable)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return _this.props.handleFormSubmit({
                row: row,
                values: values,
                routes: routes,
                fieldTypes: form.fields,
                hasMatchedUser: form.isUserForm ? !(0, _isEmpty2["default"])(matchedUser) : false
              });
            case 2:
              _this.props.closeModal();
              _this.props.afterFormSubmit();
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "processBool", function (value) {
      if (value === 'true') {
        return true;
      }
      if (value === 'false') {
        return false;
      }
      return value;
    });
    _defineProperty(_this, "processCreateValue", function (f) {
      var graphqlData = _this.props.graphqlData;
      if (f.graphql && f.graphql.create && f.graphql.create.valuePath) {
        if (f.displaySettings.renderAs.includes('date')) {
          return _this.processDate((0, _get2["default"])(graphqlData, f.graphql.create.valuePath));
        }
        var gqlValue = (0, _get2["default"])(graphqlData, f.graphql.create.valuePath);
        return !(0, _isNull2["default"])(gqlValue) ? _this.processGqlData(gqlValue, f.graphql.create) : (0, _getEmptyFieldValue["default"])(f);
      }
      if (!(0, _isEmpty2["default"])(f.displaySettings.fieldProps) && f.displaySettings.fieldProps.initialValue) {
        return _this.getStaticValue(f);
      }
      if (f.type === 'userDataField') {
        return (0, _get2["default"])(Fortress, f.displaySettings.fieldProps.valuePath);
      }
      return (0, _getEmptyFieldValue["default"])(f);
    });
    _defineProperty(_this, "processDate", function (value) {
      return (0, _moment["default"])(value).format('YYYY-MM-DD HH:mm:ss');
    });
    _defineProperty(_this, "processEditValue", function (f) {
      if (f.graphql && f.graphql.edit && f.graphql.edit.valuePath) {
        if (f.displaySettings.renderAs.includes('date')) {
          var initialValue = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
          if (initialValue) {
            initialValue = _this.processDate(initialValue);
          }
          return initialValue;
        }
        if (f.displaySettings.renderAs === 'table') {
          if (f.displaySettings.fieldProps.selectionType === 'multi') {
            // multi select table
            var _pawnCollection = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.optionsPath);
            var _stringRows = [];
            if (_pawnCollection && _pawnCollection.length) {
              _pawnCollection.forEach(function (pc) {
                _stringRows.push((0, _get2["default"])(pc, f.graphql.edit.valuePath));
              });
            }
            return (0, _isEmpty2["default"])(_stringRows) ? null : _stringRows;
          }

          // single select table
          var pawnCollection = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
          if (f.graphql.edit.skipPawnCollectionProcessing) {
            return pawnCollection;
          }
          var stringRows = [];
          if (pawnCollection && pawnCollection.length) {
            pawnCollection.forEach(function (pc) {
              stringRows.push(pc.pawn.pawnId);
            });
          }
          return (0, _isEmpty2["default"])(stringRows) ? null : stringRows;
        }
        if ((f.displaySettings.renderAs === 'select' || f.displaySettings.renderAs === 'enum') && f.displaySettings.selectionType === 'multi') {
          var _gqlValue = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
          _gqlValue = typeof _gqlValue === 'string' && _gqlValue !== '' ? JSON.parse(_gqlValue) : _gqlValue || [];
          return 'fieldSettings' in f.graphql.edit && 'valueFieldPath' in f.graphql.edit.fieldSettings ? _gqlValue.map(function (d) {
            return (0, _get2["default"])(d, f.graphql.edit.fieldSettings.valueFieldPath);
          }) : _gqlValue;
        }
        var gqlValue = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
        return !(0, _isNull2["default"])(gqlValue) ? _this.processGqlData(gqlValue, f.graphql.edit) : (0, _getEmptyFieldValue["default"])(f);
      }
      if (!(0, _isEmpty2["default"])(f.displaySettings.fieldProps) && f.displaySettings.fieldProps.initialValue) {
        // editing & static initial value
        return _this.getStaticValue(f);
      }
      if (f.type === 'userDataField') {
        return (0, _get2["default"])(Fortress, f.displaySettings.fieldProps.valuePath);
      }
      return undefined;
    });
    _defineProperty(_this, "processGqlData", function (data, settings) {
      if ('dataProcessor' in settings) {
        return _dataProcessors["default"][settings.dataProcessor](data);
      }
      return data;
    });
    _defineProperty(_this, "processInitialValue", function (f) {
      return (0, _isEmpty2["default"])(_this.props.row) ? _this.processCreateValue(f) : _this.processEditValue(f);
    });
    _defineProperty(_this, "renderForm", function () {
      var _this$props3 = _this.props,
        checkingUser = _this$props3.checkingUser,
        form = _this$props3.form,
        graphqlData = _this$props3.graphqlData,
        row = _this$props3.row;
      var sortedFields = _this.sortFields(form.fields);
      var reduxFormFields = [];
      var initialValues = {};
      sortedFields.forEach(function (f) {
        reduxFormFields.push(f.reduxFieldHandle);
        initialValues[f.reduxFieldHandle] = _this.processInitialValue(f);
      });
      reduxFormFields.push('formHandle');
      initialValues.formHandle = form.handle;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, checkingUser && /*#__PURE__*/_react["default"].createElement(_cccisdSpinner["default"], {
        options: {
          scale: 0.6,
          lines: 8,
          top: 0,
          left: '100%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_DynamicForm["default"], {
        fields: reduxFormFields,
        fieldTypes: _this.getFieldTypes(sortedFields),
        onSubmit: _this.handleSubmit,
        initialValues: initialValues,
        loadedData: graphqlData,
        operation: (0, _isEmpty2["default"])(row) ? 'create' : 'edit',
        row: (0, _isEmpty2["default"])(row) ? {} : row,
        shouldCheckUser: !!form.isUserForm,
        checkUserSettings: !!form.isUserForm && 'userCheckSettings' in form ? form.userCheckSettings : {}
      }));
    });
    _defineProperty(_this, "sortFields", function (fields) {
      // sort fields
      return (0, _sortBy2["default"])(fields, [function (f) {
        return f.order;
      }]);
    });
    return _this;
  }
  _inherits(FormWrapper, _React$Component);
  return _createClass(FormWrapper, [{
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      if (this.props.loading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].loading
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true,
          type: "inline"
        }));
      }
      return this.renderForm();
    }
  }]);
}(_react["default"].Component);
_defineProperty(FormWrapper, "propTypes", {
  /** Optional custom callback for after the form has been submitted */
  afterFormSubmit: _propTypes["default"].func,
  checkingUser: _propTypes["default"].bool,
  /** Function that will close the modal holding the form */
  closeModal: _propTypes["default"].func,
  /** Filter by Group Id */
  filterGroup: _propTypes["default"].number,
  /** JSON definition of the form */
  form: _propTypes["default"].object,
  /** The graphql data from the server */
  graphqlData: _propTypes["default"].object,
  /** Reducer handleSubmit */
  handleFormSubmit: _propTypes["default"].func,
  loading: _propTypes["default"].bool,
  /** The userCheck user object */
  matchedUser: _propTypes["default"].object,
  resetState: _propTypes["default"].func,
  /** JSON for CRUD and data routes */
  routes: _propTypes["default"].object,
  /** The row for form edits */
  row: _propTypes["default"].object,
  /** Run a query to populate the graphqlData object */
  runQuery: _propTypes["default"].func,
  /** The userCheck set user function */
  setMatchedUser: _propTypes["default"].func,
  /** Erase current graphql data */
  unsetGraphqlData: _propTypes["default"].func,
  unsetLoadingState: _propTypes["default"].func,
  /** Is the user available? */
  userAvailable: _propTypes["default"].bool
});
_defineProperty(FormWrapper, "defaultProps", {
  routes: {},
  afterFormSubmit: function afterFormSubmit() {},
  form: {},
  row: {}
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    checkingUser: state.appdefs.formWrapper.checkingUser,
    graphqlData: state.appdefs.formWrapper.graphqlData,
    loading: state.appdefs.formWrapper.loading,
    matchedUser: state.appdefs.formWrapper.matchedUser,
    userAvailable: state.appdefs.formWrapper.userAvailable
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  handleFormSubmit: _formWrapper.handleFormSubmit,
  resetState: _formWrapper.resetState,
  runQuery: _formWrapper.runQuery,
  setMatchedUser: _formWrapper.setMatchedUser,
  unsetGraphqlData: _formWrapper.unsetGraphqlData,
  unsetLoadingState: _formWrapper.unsetLoadingState
})(FormWrapper);